import React from "react";
import { FLAGS } from "@/components/LanguageSwitcher";

export default function FaqMarketToggle({ t, value, onChange, testid = "faq-market" }) {
  const opts = [["nl", "NL", t("country.nl")], ["fr", "FR", t("country.fr")]];
  return (
    <div role="group" aria-label={t("country.label")} data-testid={testid} className="inline-flex items-center rounded-full bg-white p-0.5 ring-1 ring-slate-200">
      {opts.map(([code, flag, label]) => (
        <button key={code} type="button" onClick={() => onChange(code)} aria-pressed={value === code} data-testid={`${testid}-${code}`}
          className={`inline-flex items-center gap-1.5 rounded-full px-3 h-8 text-xs font-semibold transition-[background-color,color] ${value === code ? "bg-[#1B3A6B] text-white" : "text-slate-500 hover:text-[#1B3A6B]"}`}>
          <span className="block w-4 h-4 rounded-full overflow-hidden ring-1 ring-black/10">{FLAGS[flag]}</span>{label}
        </button>
      ))}
    </div>
  );
}
